var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", { attrs: { "no-sidebar": true, "no-box": true } }, [
    _c("div", { staticClass: "box" }, [
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
          ])
        : _c("div", { staticClass: "box-body" }, [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "div",
                  { staticClass: "col-sm-8 col-sm-offset-2 margin-top-3x" },
                  [
                    _c(
                      "div",
                      { staticClass: "text-right margin-bottom-3x" },
                      [
                        _c("new-external-email", {
                          directives: [
                            {
                              name: "hasPermits",
                              rawName: "v-hasPermits:allow",
                              value: ["super_admin"],
                              expression: "['super_admin']",
                              arg: "allow"
                            }
                          ],
                          staticClass: "margin-bottom-3x"
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-responsive" }, [
                      _c(
                        "table",
                        { staticClass: "table table-striped margin-top-3x" },
                        [
                          _vm.externalEmails.length
                            ? _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v(" Email ")]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(" Send New Location Email ")
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.externalEmails, function(
                                external_email
                              ) {
                                return _vm.externalEmails.length
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          " " +
                                            _vm._s(external_email.email) +
                                            " "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "label",
                                          { staticClass: "checkbox-inline" },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked:
                                                  external_email.send_new_location_email
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.updateExternalEmail(
                                                    external_email,
                                                    "send_new_location_email",
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermits",
                                                rawName: "v-hasPermits:allow",
                                                value: ["super_admin"],
                                                expression: "['super_admin']",
                                                arg: "allow"
                                              }
                                            ],
                                            staticClass: "btn btn-danger",
                                            class: {
                                              disabled:
                                                _vm.loadings[external_email.id]
                                            },
                                            attrs: {
                                              disabled:
                                                _vm.loadings[external_email.id]
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.removeEmail(
                                                  external_email
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm.loadings[external_email.id]
                                              ? _c("span", [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-spinner fa-spin"
                                                  })
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.loadings[external_email.id]
                                              ? _c("i", {
                                                  staticClass: "fa fa-trash",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                      Remove\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              !_vm.externalEmails.length
                                ? _c("tr", [
                                    _c("td", { attrs: { colspan: "4" } }, [
                                      _vm._v(
                                        "\n                    No emails has been added yet.\n                  "
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("confirm", {
                  ref: "confirmDelete",
                  attrs: { type: "danger" }
                })
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fa2deee", { render: render, staticRenderFns: staticRenderFns })
  }
}